import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: '100%',
      padding: 0,

      '& .MuiStepConnector-line': {
        color: '#CECFCE',
        margin: '0 3rem',
      },
    },
    labelStepRoot: {
      '& .MuiStepLabel-label': {
        color: '#CECFCE',

        '&.MuiStepLabel-active, &.MuiStepLabel-completed': {
          color: theme.palette.text.secondary,
        },
      },
    },
    button: {
      marginRight: theme.spacing(1),
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    stepIcon: {
      width: 25,
      height: 25,
      borderRadius: '50%',
      borderWidth: '0.3rem',
      borderStyle: 'solid',
      borderColor: '#CECFCE',
    },
    activeStepIcon: {
      borderWidth: '0.6rem',
      borderColor: theme.palette.primary.dark,
    },
  }),
)
